import { useTranslate } from 'react-polyglot';

import { DownloadIcon } from '@genially/icons';

import { useHostClientContext } from '../../../../../HostClientProvider/hooks/useHostClientContext';
import { useHostGameContext } from '../../../../HostGame.context';
import { downloadGameResultsFromClient } from '../../../../utils/downloadGameResultsFromClient';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const DownloadResultsSidebarLink = () => {
  const t = useTranslate();
  const { settingsSidebar } = useHostGameContext();
  const { client } = useHostClientContext();

  const handleClick = async () => {
    settingsSidebar.close();

    await downloadGameResultsFromClient(client, t);
  };

  return (
    <SidebarLink
      Icon={DownloadIcon}
      text={t('__new.play.shared.downloadResults')}
      onClick={handleClick}
    ></SidebarLink>
  );
};
